import { render, staticRenderFns } from "./form-design.vue?vue&type=template&id=5c1de3b5"
import script from "./form-design.vue?vue&type=script&lang=js"
export * from "./form-design.vue?vue&type=script&lang=js"
import style0 from "./form-design.vue?vue&type=style&index=0&id=5c1de3b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports